import { UserOutlined } from "@ant-design/icons";
import { Avatar, Typography, Flex, Input } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { useTranslate } from "#src/hooks";

export const NameStep = ({
  contactName,
  setContactName,
  isVoiceOnly,
}: {
  contactName: string;
  setContactName: React.Dispatch<React.SetStateAction<string>>;
  isVoiceOnly: boolean;
}) => {
  const { theme } = useAntTheme();
  const t = useTranslate();
  return (
    <>
      <Avatar
        size={150}
        icon={<UserOutlined style={{ fontSize: 60 }} />}
        style={{
          backgroundColor: "#D8F6F4",
          color: theme.colorPrimary,
        }}
      />
      <Flex vertical gap={40} style={{ width: "100%" }}>
        <Typography.Title
          level={2}
          style={{
            margin: 0,
            fontWeight: 500,
          }}
        >
          {t("src.components.ContactCloningMobile.whatsTheirName")}
        </Typography.Title>
        <Input
          value={contactName}
          onChange={(e) => setContactName(e.target.value)}
          placeholder={t(
            "src.components.ContactCloningMobile.contactNamePlaceholder"
          )}
          height={isVoiceOnly ? 40 : 60}
          style={{
            fontSize: isVoiceOnly ? 16 : 20,
            width: "100%",
            border: "none",
            borderBottom: `2px solid ${theme.colorPrimary}`,
            borderRadius: 0,
            paddingLeft: 0,
          }}
        />
      </Flex>
    </>
  );
};
